










import { defineComponent, ref } from '@vue/composition-api'
import { useTournament } from '../../reactive/tournament.state'
import { API } from '../../api'

export default defineComponent({
  setup(props, { root }) {
    const { clearTournament } = useTournament()

    const hasFailed = ref(false)
    const isPending = ref(false)

    async function submit() {
      isPending.value = true
      hasFailed.value = false
      const response = await API.Tournament.destroy(root.$route.params.hash)
      if (response.isSuccessful) {
        clearTournament()
        root.$router.replace({ name: 'home.index' })
      } else {
        hasFailed.value = true
      }
    }

    return {
      isPending,
      hasFailed,
      submit,
    }
  },
})
